// AutoGenerated
export enum EnmIcerikTip {
    "PDF" = 1,
    "Ses" = 2,
    "Midi" = 3,
    "Avatar" = 4,
    "KoroLogo" = 5,
    "Herşey" = 6,
    "Konser Afiş" = 7,
    "PDF Notları" = 8,
}